/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {NoteId, NoteInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditRepresentativeNoteUrl = (id: string, noteId: NoteId) => {
  return `/api/v1/sales/representatives/${id}/notes/${noteId}`;
};

/**
 * @summary Edit representative note
 */
export const editRepresentativeNote = async (
  id: string,
  noteId: NoteId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditRepresentativeNoteUrl(id, noteId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getRemoveRepresentativeNoteUrl = (id: string, noteId: NoteId) => {
  return `/api/v1/sales/representatives/${id}/notes/${noteId}`;
};

/**
 * @summary Remove representative note
 */
export const removeRepresentativeNote = async (
  id: string,
  noteId: NoteId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveRepresentativeNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddRepresentativeNoteUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}/notes`;
};

/**
 * @summary Add representative note
 */
export const addRepresentativeNote = async (
  id: string,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NoteId> => {
  return customFetch<NoteId>(getAddRepresentativeNoteUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};
